/** WARNING: Assumes that all ID properties will have the global type ID */
export function hasId(obj: unknown): obj is { id: ID } {
  return Object.prototype.hasOwnProperty.call(obj, 'id');
}
